// CompanySelect.jsx
import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from "@mui/material";
import { getSpeciesLookup } from "../../../api/petService";

const SpeciesSelect = ({ speciesId = "", value, onChange, label = "Select Species", ...props }) => {

    const [species, setSpecies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSpecies = async () => {
        try {
            const response = await getSpeciesLookup();
            setSpecies(response);
            } catch (error) {
                console.error("Error fetching species:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSpecies();
    }, [speciesId]);

  return (
    <FormControl fullWidth {...props}>
      <InputLabel>{label}</InputLabel>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <Select value={value} onChange={onChange} label={label}>
          {species.data.map((specie) => (
            <MenuItem key={specie.id} value={specie.id}>
              {specie.label}
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default SpeciesSelect;